import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MonthlyPaymentMode } from 'src/app/models/virtual-store/monthly-payment.model';
import { OrderItemInsertRequest } from 'src/app/models/virtual-store/order-item-insert-request.model';
import { Service } from 'src/app/models/virtual-store/service.model';
import { OrderItemService } from 'src/app/services/order-item.service';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { Router } from '@angular/router';
import { AppConstant } from 'src/app/constants/app.constant';

@Component({
  selector: 'app-popup-service-list',
  templateUrl: './popup-service-list.component.html',
  styleUrls: ['./popup-service-list.component.scss']
})
export class PopupServiceListComponent implements OnInit {

  clientCode: string;
  serviceList: Service[] = [];
  selectedMonthlyPaymentMode = new MonthlyPaymentMode();
  codeFilterFnb:string=AppConstant.FNB;  
  product:any;
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<any>,
  private orderItemService: OrderItemService,
  private virtualStoreService: VirtualStoreService,
  private router: Router) { }

  ngOnInit() {
    this.serviceList = this.data.serviceList;
    this.clientCode = this.data.clientCode;
    this.product = this.data.product;

    this.serviceList.forEach(element => {
      element.aggregate = false;
      element.selectedMonthlyPaymentMode = element.monthlyPaymentModeList.length > 0 ? element.monthlyPaymentModeList[0]: [];
    });
  }

  addServiceCart(item: Service){
    const orderItem = new OrderItemInsertRequest();
    orderItem.productId = item.serviceId;
    orderItem.count = 1;
    orderItem.clientCode = this.clientCode;
    orderItem.monthlyPaymentCount = item.selectedMonthlyPaymentMode.monthCount;

    this.orderItemService.addPendingOne(orderItem).subscribe(response => {
      if (response.valid) {
        this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
        this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);

        const pedido = response.data.pendingOrderItemList.filter( x => x.product.id === item.serviceId);

        if(pedido.length > 0)
        {
          item.orderItemId = pedido[0].id;
        }

        item.aggregate = true;
      }
    });
  }

  removeServiceCart(item: Service) {
    this.orderItemService.removePendingOne(item.orderItemId, this.clientCode,false).subscribe(response => {
      if (response.valid) {

        item.aggregate = false;
        item.selectedMonthlyPaymentMode = item.monthlyPaymentModeList[0];

        this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
        this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);
      }
    })
  }

  continue()
  {
    this.dialogRef.close();
    this.router.navigate(['ofivirtual/tienda/mi-carrito']);
  }

  add()
  {
    this.dialogRef.close();
    this.router.navigate(['ofivirtual/tienda']);
  }

}
